import { render } from "./ReloadNotice.vue?vue&type=template&id=387269da&scoped=true"
import script from "./ReloadNotice.vue?vue&type=script&lang=ts"
export * from "./ReloadNotice.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-387269da"

export default script